export default "__VITE_ASSET__kRx4iQw6__"